import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNUser } from 'src/app/models/cnuser';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  @Input() users: CNUser[] = [];
  @Input() mode = 'summary';
  @Input() actions = [];

  @Output() selected: EventEmitter<CNUser> = new EventEmitter();
  @Output() remove: EventEmitter<CNUser> = new EventEmitter();
  public selectedUser: CNUser;

  constructor(users: UserService) { }

  ngOnInit(): void {
  }

  public select(user: CNUser) {
    this.selectedUser = user;
    this.selected.emit(user);
  }

  public style() {
    if (this.mode === 'admin') {
      return 'height: 65px;';
    }
    return 'height: 130px;';
  }

  removeUser(user: CNUser): void {
    this.remove.emit(user);
  }
}
